export default {
  resource:{
    zh: {
      title:"考勤汇总",
      xdate: "日期",
      xdate1: "开始日期",
      xdate2: "结束日期",
      companyNo:"公司",
      companyName:"公司",
      deptNo: "部门",
      deptName: "部门",
      job:"岗位",
      empId:"工号",
      empName:"姓名",

      arriveDate:"报到日",
      totalDay:"总出勤(天)",
      totalTime:"总出勤(时)",
      wt:"总工作(时)",
      ot:"总加班(时)",
      
      workDay:"一至五工作(天)",
      workTime:"一至五工作(时)",
      overTime:"一至五加班(时)",

      satDay:"六、日加班(天)",
      satOT:"六、日加班(时)",

      holidayOTDay: "无休假(天)",
      holidayOT: "无休假(时)",

      absenceTime:"缺勤(分)",
      absenceHour: "缺勤(时)",
      absenceDay: "缺勤(天)",
      lateTime:"迟到(分)",
      lateDay: "迟到(天)",
      earlyTime:"早退(分)",
      earlyDay: "早退(天)",
      leaveTime:"请假(时)",
      leaveDay: "请假(天)",
      holidayTime:"放假(时)",
      holidayDay: "放假(天)",
      restTime:"调休(时)",
      restDay: "调休(天)",
      nightDay:"夜班(天)",
      paidLeaveTime:"有薪假(时)",
      paidLeaveDay: "有薪假(天)",
      injuryTime:"工伤(时)",
      injuryDay:"工伤(天)",
      travelDay:"出差（天）",
      fillCardTimes:"补卡次数"
    }

  },
  params: {
    companyNo:{
      key: "companyNo",
      defaultIdx: 0,
      method: "Equal",
      type: "select",
      options:"company"
    },
    xdate1:{
      key: "xdate1",
      tkey: "xdate1",
      data: null,
      method: "GreaterThanOrEqual",
      type: "date"
    },
    xdate2:{
      key: "xdate2",
      tkey: "xdate2",
      data: null,
      method: "LessThanOrEqual",
      type: "date"
    },
    empId:{
      key: "empId",
      data: null,
      more: true,
      method: "Equal",
      type: "number"
    },
    empName:{
      key: "empName",
      data: null,
      more: true,
      method: "Contains",
      type: "text"
    },
    deptNo:{
      key: "deptNo",
      data: "",
      more: true,
      method: "Equal",
      type: "select",
      options:[{
        value: "",
        text: "All"
      }]
    }
  },
  listDefine: [
    "deptName","job","empId", "empName",
   
    {key:"arriveDate", formatter:"fdate"},
    {
      key: "totalDay",
      type: "sortClumn",
      formatter:"fix2"
    },

    {
      key: "totalTime",
      type: "sortClumn",
      formatter:"fix2"
    },

    {
      key: "wt",
      type: "sortClumn",
      formatter:"fix2"
    },

    {
      key: "ot",
      type: "sortClumn",
      formatter:"fix2"
    },

    
    {key:"workDay", formatter:"fix2"},

    {
      key: "workTime",
      type: "sortClumn",
      formatter:"fix2"
    },
    {
      key: "overTime",
      type: "sortClumn",
      formatter:"fix2"
    },

    {
      key: "satDay",
      type: "sortClumn",
      formatter:"fix2"
    },


    {
      key: "satOT",
      type: "sortClumn",
      formatter:"fix2"
    },





    {
      key: "absenceTime",
      type: "sortClumn",
      formatter:"fix2"
    },
      "absenceHour",
    {
      key: "absenceDay",
      type: "sortClumn",
      formatter:"fix2"
    },
    {
      key: "lateTime",
      type: "sortClumn"
    },
    {
      key: "lateDay",
      type: "sortClumn",
      formatter:"fix2"
    },
    {
      key: "earlyTime",
      type: "sortClumn"
    },
    {
      key: "earlyDay",
      type: "sortClumn",
      formatter:"fix2"
    },
    {
      key: "leaveTime",
      type: "sortClumn",
      formatter:"fix2"
    },
    {
      key: "leaveDay",
      type: "sortClumn",
      formatter:"fix2"
    },
    
    {
      key: "holidayTime",
      type: "sortClumn",
      formatter:"fix2"
    },
    {
      key: "holidayDay",
      type: "sortClumn",
      formatter:"fix2"
    },
    {
      key: "restTime",
      type: "sortClumn",
      formatter:"fix2"
    },
    {
      key: "restDay",
      type: "sortClumn",
      formatter:"fix2"
    },
    
    {
      key: "nightDay",
      type: "sortClumn",
      formatter:"fix2"
    },
    {
      key: "paidLeaveTime",
      type: "sortClumn",
      formatter:"fix2"
    },
    {
      key: "paidLeaveDay",
      type: "sortClumn",
      formatter:"fix2"
    },
    {
      key: "injuryTime",
      type: "sortClumn",
      formatter:"fix2"
    },
    {
      key: "injuryDay",
      type: "sortClumn",
      formatter:"fix2"
    },
    {
      key: "travelDay",
      type: "sortClumn",
      formatter:"fix2"
    },
    "fillCardTimes"
  ],
  isShowMore: true,
  bodyClass: "table-select", //table-multiselect table-select
  list: [],
  defaultSortName: "deptName",
  defaultSortOrder: "asc",
  sortName: "deptName",
  sortOrder: "asc",
  pageNo: 1,
  pageSize: 18,
  rowCount: 1,
  url: "summary/",
  formatter: {
    fix1(v) {
      if (v<0.1) return ""
      return this.numberFix1(v)
    },
    fix2(v) {
      if (v<0.01) return ""
      return this.numberFix2(v)
    }
  }

}
